module.exports = __webpack_public_path__ + "static/img/h5-1.70c2728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-1.png
// module id = fKP/
// module chunks = 1